/* ══════════════════════════════════════
   Monmouth Cards — Product Detail Page JS
   assets/monmouth-pdp.js
   ══════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Gallery Thumbnails ── */
  var thumbs  = document.querySelectorAll('.mc-pdp__thumb');
  var mainImg = document.querySelector('.mc-pdp__gallery-main img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('mc-pdp__thumb--active'); });
      thumb.classList.add('mc-pdp__thumb--active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src     = thumb.dataset.src;
        mainImg.srcset  = thumb.dataset.srcset || '';
      }
    });
  });

  /* ── Quantity Stepper ── */
  var qtyInput = document.querySelector('.mc-pdp__qty-input');
  var qtyMinus = document.querySelector('.mc-pdp__qty-btn[data-action="minus"]');
  var qtyPlus  = document.querySelector('.mc-pdp__qty-btn[data-action="plus"]');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value) || 1;
      var max = parseInt(qtyInput.getAttribute('max')) || 99;
      qtyInput.value = Math.min(max, val + 1);
    });
  }

  /* ── Variant Selector ──
     Real fix (pdp-variant-wrong-item-bug-prompt.md) — this used to just
     overwrite the hidden `id` input with whatever single variant ID was
     baked into the clicked button, with no concept of "Size=Large AND
     Color=Blue selected together." On any product with 2+ option axes,
     whichever button was clicked LAST won using its own baked-in ID, which
     for many real combinations was a genuinely wrong variant — sometimes
     with no click order that reached the correct one at all. Fix: track
     the customer's selection per axis, and re-resolve the exact matching
     variant from the full embedded variant list on every click, instead of
     trusting a value baked into one button ahead of time. */
  var variantBtns    = document.querySelectorAll('.mc-pdp__variant');
  var variantInput   = document.getElementById('mc-pdp-variant-id');
  var priceEl        = document.querySelector('.mc-pdp__price');
  var stickyPrice    = document.querySelector('.mc-pdp__sticky-bar-price');
  var skuEl          = document.getElementById('mc-pdp-sku-value');
  var variantsDataEl = document.getElementById('mc-pdp-variants-data');
  var initialSelEl   = document.getElementById('mc-pdp-initial-selection');

  if (variantBtns.length && variantsDataEl && initialSelEl) {
    var mcVariants = [];
    var mcSelection = [];
    try {
      mcVariants  = JSON.parse(variantsDataEl.textContent) || [];
      mcSelection = JSON.parse(initialSelEl.textContent) || [];
    } catch (e) { mcVariants = []; mcSelection = []; }

    function mcFindVariant(selection) {
      for (var i = 0; i < mcVariants.length; i++) {
        var v = mcVariants[i];
        var isMatch = true;
        for (var axis = 0; axis < selection.length; axis++) {
          if (v.options[axis] !== selection[axis]) { isMatch = false; break; }
        }
        if (isMatch) return v;
      }
      return null;
    }

    function mcRefreshButtonStates() {
      variantBtns.forEach(function (b) {
        var axisIndex = parseInt(b.dataset.optionIndex, 10);
        var value = b.dataset.optionValue;

        b.classList.toggle('mc-pdp__variant--active', mcSelection[axisIndex] === value);

        var candidate = mcSelection.slice();
        candidate[axisIndex] = value;
        var candidateVariant = mcFindVariant(candidate);
        var unavailable = !candidateVariant || candidateVariant.available === false;
        b.classList.toggle('mc-pdp__variant--unavailable', unavailable);
        if (candidateVariant) b.dataset.price = candidateVariant.price;
      });
    }

    function mcApplyResolvedVariant(variant) {
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      var stickyInput = document.querySelector('.mc-pdp__sticky-bar input[name="id"]');
      if (stickyInput) stickyInput.value = variant.id;

      if (priceEl) priceEl.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      var addBtnNow = document.querySelector('.mc-pdp__add-btn');
      if (addBtnNow && !addBtnNow.disabled) {
        addBtnNow.textContent = addBtnNow.textContent.replace(/—.*$/, '— ' + variant.price);
      }
      if (skuEl) skuEl.textContent = variant.sku || 'N/A';

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    /* Initial render may have picked a button as --active/--unavailable
       purely from current_variant's own combination at page load — refresh
       once up front so state is consistent with this same JS logic. */
    mcRefreshButtonStates();

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('mc-pdp__variant--unavailable')) return;

        var axisIndex = parseInt(btn.dataset.optionIndex, 10);
        mcSelection[axisIndex] = btn.dataset.optionValue;

        var resolved = mcFindVariant(mcSelection);
        mcApplyResolvedVariant(resolved);
        mcRefreshButtonStates();
      });
    });
  }

  /* Real race-condition fix (referral-code-race-condition-add-to-cart-
     prompt.md) — reads the mc_ref_code cookie set by layout/theme.liquid
     and returns it as a cart-attributes fragment to merge into a /cart/
     add.js call, so the code lands in the SAME request that adds the
     item instead of racing a separate background sync call. This is the
     main product page's Add to Cart — the exact call site involved in
     the confirmed live race (order #1041/#1042). */
  function mcGetReferralAttribute() {
    var m = document.cookie.match(/(?:^|; )mc_ref_code=([^;]*)/);
    return m ? { mc_ref_code: decodeURIComponent(m[1]) } : {};
  }

  /* ── AJAX Add to Cart ── */
  function ajaxAddToCart(form, btn) {
    var variantId = form.querySelector('[name="id"]').value;
    var quantity  = parseInt((form.querySelector('[name="quantity"]') || {}).value || 1);
    var original  = btn.textContent;

    btn.textContent = 'Adding…';
    btn.disabled    = true;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: quantity, attributes: mcGetReferralAttribute() })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          /* Shopify returned an error object */
          btn.textContent = data.description || 'Error';
          btn.disabled    = false;
          setTimeout(function () { btn.textContent = original; }, 2500);
          return;
        }
        btn.textContent = '✓ Added!';
        try { sessionStorage.setItem('mc_last_added_variant_id', String(data.variant_id || variantId)); } catch (e) { /* no-op */ }

        /* Analytics: fire add_to_cart (helper defined in monmouth-integrations) */
        try {
          if (window.mcTrack && typeof window.mcTrack.addToCart === 'function') {
            window.mcTrack.addToCart({
              id: data.product_id || variantId,
              title: data.product_title || data.title,
              price: (typeof data.price === 'number' ? data.price / 100 : undefined)
            }, quantity);
          }
        } catch (e) { /* no-op */ }

        /* Tell cart.js to update count + re-render drawer */
        document.dispatchEvent(new CustomEvent('mc:cart-updated'));
        /* Open the cart drawer */
        document.dispatchEvent(new CustomEvent('mc:open-cart-drawer'));

        setTimeout(function () {
          btn.textContent = original;
          btn.disabled    = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Error — try again';
        btn.disabled    = false;
        setTimeout(function () { btn.textContent = original; }, 2500);
      });
  }

  /* Main add-to-cart form */
  var addForm = document.querySelector('.mc-pdp__add-form');
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = addForm.querySelector('.mc-pdp__add-btn');
      if (submitBtn && !submitBtn.disabled) ajaxAddToCart(addForm, submitBtn);
    });
  }

  /* Sticky ATC bar form */
  var stickyForm = document.querySelector('.mc-pdp__sticky-bar form');
  if (stickyForm) {
    stickyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = stickyForm.querySelector('.mc-pdp__sticky-bar-btn');
      if (submitBtn) ajaxAddToCart(stickyForm, submitBtn);
    });
  }

  /* ── Description Tabs ── */
  var tabs = document.querySelectorAll('.mc-pdp__tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.tab;
      tabs.forEach(function (t) { t.classList.remove('mc-pdp__tab--active'); });
      document.querySelectorAll('.mc-pdp__tab-panel').forEach(function (p) {
        p.classList.remove('mc-pdp__tab-panel--active');
      });
      tab.classList.add('mc-pdp__tab--active');
      var panel = document.getElementById('mc-tab-' + target);
      if (panel) panel.classList.add('mc-pdp__tab-panel--active');
    });
  });

  /* ── Accordion Toggle ── */
  document.querySelectorAll('.mc-pdp__accordion-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var acc = header.closest('.mc-pdp__accordion');
      if (acc) acc.classList.toggle('mc-pdp__accordion--open');
    });
  });

  /* ── Sticky ATC Bar (show on scroll past main ATC) ── */
  var stickyBar      = document.querySelector('.mc-pdp__sticky-bar');
  var addToCartBlock = document.querySelector('.mc-pdp__actions');

  if (stickyBar && addToCartBlock) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('mc-pdp__sticky-bar--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(addToCartBlock);
  }

  /* ── Related Products ──
     Real fix (search-engine-visibility-prompt.md part 6) — the section
     used to gate on `recommendations.performed`, which nothing in this
     theme ever makes true (that only fires when Shopify itself renders
     this section through its Section Rendering API recommendations
     endpoint). Uses Shopify's simpler JSON recommendations endpoint
     instead, which needs no special wiring, and renders into the same
     .mc-pdp__related-grid the old code targeted — same card markup/
     classes as snippets/monmouth-product-card.liquid so it's styled
     identically to every other product card on the site. */
  function mcMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function mcEscHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function mcRenderRelatedCard(p) {
    var variants = p.variants || [];
    var firstVariant = variants[0];
    var isSale = firstVariant && firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price;
    var titleEsc = mcEscHtml(p.title);
    var img = p.featured_image || (p.images && p.images[0]) || '';

    var actionHtml;
    if (p.available === false) {
      actionHtml = '<button class="mc-product-card__btn mc-product-card__btn--soldout" disabled>Sold Out</button>';
    } else if (variants.length === 1 && firstVariant) {
      actionHtml =
        '<form method="post" action="/cart/add">' +
          '<input type="hidden" name="id" value="' + firstVariant.id + '">' +
          '<button type="submit" class="mc-product-card__btn">Add to Cart</button>' +
        '</form>';
    } else {
      actionHtml = '<a href="' + p.url + '" class="mc-product-card__btn">Select Options</a>';
    }

    return (
      '<div class="mc-product-card">' +
        '<a href="' + p.url + '" class="mc-product-card__img-link">' +
          '<div class="mc-product-card__img">' +
            (img
              ? '<img src="' + img + '" alt="' + titleEsc + '" width="200" height="280" loading="lazy" class="mc-product-card__image">'
              : '') +
            (p.available === false
              ? '<span class="mc-product-card__badge mc-badge mc-badge--soldout">Sold Out</span>'
              : (isSale ? '<span class="mc-product-card__badge mc-badge mc-badge--sale">Sale</span>' : '')) +
          '</div>' +
        '</a>' +
        '<div class="mc-product-card__body">' +
          '<a href="' + p.url + '" class="mc-product-card__title" title="' + titleEsc + '">' + titleEsc + '</a>' +
          '<div class="mc-product-card__price' + (isSale ? ' mc-product-card__price--sale' : '') + '">' +
            '<span class="mc-product-card__price-current">' + mcMoney(p.price) + '</span>' +
            (isSale ? '<span class="mc-product-card__price-compare">' + mcMoney(firstVariant.compare_at_price) + '</span>' : '') +
          '</div>' +
          actionHtml +
        '</div>' +
      '</div>'
    );
  }

  var relatedEl = document.getElementById('mc-pdp-related');
  if (relatedEl) {
    var relatedProductId = relatedEl.dataset.productId;
    var relatedLimit = parseInt(relatedEl.dataset.limit, 10) || 4;
    var relatedGrid = document.getElementById('mc-pdp-related-grid');

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(relatedProductId) + '&limit=' + relatedLimit + '&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        /* Real fix (pre-launch-remaining-fixes-prompt.md, Part 4) — this
           only ever excluded the current product's own id; a sold out
           recommended product still rendered with a "Sold Out" badge
           instead of being left out, unlike every other product grid on
           the site. */
        var products = ((data && data.products) || []).filter(function (p) {
          return String(p.id) !== String(relatedProductId) && p.available !== false;
        });
        if (!products.length || !relatedGrid) return;
        relatedGrid.innerHTML = products.map(mcRenderRelatedCard).join('');
        relatedEl.hidden = false;
      })
      .catch(function () { /* fail quietly — no empty state, no error message */ });
  }

})();
